import {
  createUnitTypeOptions,
  WORKING_DECLARATION_LABEL_KEYS,
} from '@/config/unitTypes.constants';

// An allocation carries its certified quantity in the working and declaration units.
export const { unitTypeLabel, buildRowUnitOptions, buildUnitHeaderOptions } = createUnitTypeOptions(
  WORKING_DECLARATION_LABEL_KEYS,
);
